import { Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../redux/slice/authSlice";
import { ImageUrl } from "../../helpers/Functions";
import { FiLogOut } from "react-icons/fi";
import "./associate-layout.css";

export function getAssociateInitials(user) {
  const first = user?.firstName?.[0] || "";
  const last = user?.lastName?.[0] || "";
  const initials = `${first}${last}`.toUpperCase();
  return initials || "A";
}

function AssociateLayout({ children, footer = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);

  const logout = () => {
    dispatch(removeUser());
    navigate("/associate/signin");
  };

  const displayName = user?.firstName
    ? `${user.firstName} ${user.lastName || ""}`.trim()
    : "Associate";

  const initials = getAssociateInitials(user);

  return (
    <Layout className="associate-layout">
      <header className="associate-layout-header">
        <div
          className="associate-layout-brand"
          onClick={() => navigate("/associate/dashboard")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/associate/dashboard");
            }
          }}
          role="button"
          tabIndex={0}
        >
          <img
            src={ImageUrl("fav.png")}
            alt="WrightCo Academy"
            width={40}
            height={40}
            style={{ objectFit: "contain" }}
          />
          <span className="associate-layout-brand__title fontFamily1">
            Associate Portal
          </span>
        </div>

        <div className="associate-layout-actions">
          <span className="associate-layout-welcome fontFamily1">
            Welcome, <strong>{displayName}</strong>
          </span>
          <span className="associate-layout-avatar-sm" aria-hidden>
            {initials}
          </span>
          <button
            type="button"
            className="associate-layout-logout fontFamily1"
            onClick={logout}
          >
            <FiLogOut aria-hidden />
            Logout
          </button>
        </div>
      </header>
      {children}
      {footer ? (
        <div
          style={{
            textAlign: "center",
            padding: "24px 16px",
            color: "#888",
            borderTop: "1px solid #e6eaef",
            background: "#fff",
          }}
        >
          WrightCo Academy — Training Associate
        </div>
      ) : null}
    </Layout>
  );
}

export default AssociateLayout;
